import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const Divider = ({ orientation = 'horizontal', variant = 'middle', color, width, textAlign = 'center', children }) => (
  <S.Divider flexItem orientation={orientation} variant={variant} color={color} width={width} textAlign={textAlign}>
    {children}
  </S.Divider>
);

Divider.propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle']),
  width: PropTypes.string,
  color: PropTypes.string,
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),
  children: PropTypes.node
};

export default Divider;
